export default __webpack_public_path__ + "static/media/build.44ff3616.png";